import { render, staticRenderFns } from "./TilesGroup.vue?vue&type=template&id=57042fd7&scoped=true&"
import script from "./TilesGroup.vue?vue&type=script&lang=js&"
export * from "./TilesGroup.vue?vue&type=script&lang=js&"
import style0 from "./TilesGroup.vue?vue&type=style&index=0&id=57042fd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57042fd7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
